import { Menus } from '@/entities/menus'
import HGLink from '../index'
import { LinkProps } from '../links.types'
import { normalizeSlug } from '@utils'

export default function LinkCaseStudies({
  children,
  href,
  menu,
  ...props
}: LinkProps & { menu?: Menus }) {
  return (
    <HGLink
      href={href || getCaseStudiesHref(undefined, menu)}
      aria-label='go to success stories'
      {...props}
    >
      {children}
    </HGLink>
  )
}

export function LinkCaseStudiesDetail({
  children,
  slug,
  ...props
}: LinkProps & { slug: string }) {
  return (
    <HGLink
      href={getCaseStudiesDetailHref(slug)}
      aria-label='go to stories'
      {...props}
    >
      {children}
    </HGLink>
  )
}

export function getCaseStudiesHref(query?: string, menu?: Menus) {
  const slug = normalizeSlug(menu?.slug || 'success-stories')
  if (!query) {
    return `/${slug}`
  }
  return `/${slug}/${query}`
}

export function getCaseStudiesDetailHref(slug: string) {
  return `/stories/${slug}`
}
